// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import UsersGroupForm from './UsersGroupForm';

export default compose(
  connect(
    state => ({
      app: state.app
    }),
    dispatch => ({}),
  ),
)(UsersGroupForm);
